import TabList from './TabList';

export default TabList;
